// extracted by mini-css-extract-plugin
export var label = "LineRule-module--label--9fa7c";
export var segment = "LineRule-module--segment--53ada";
export var wrapper = "LineRule-module--wrapper--2ffb6";